import { Component, Input, Output, EventEmitter} from '@angular/core';
import { ExpandableListItem } from '../models/expandable-list-item.model';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { ExpandableListComponent } from './expandable-list.component';
import { MiscUtil } from '../utilities/misc.util';

@Component({
    selector: 'expandable-list-ordered',
    templateUrl: 'expandable-list-ordered.component.html',
    styleUrls: ['expandable-list-ordered.component.scss']
  })

export class ExpandableListOrderedComponent extends ExpandableListComponent {

  @Input() infoLabel: string;
  @Output() orderUpdated = new EventEmitter();

  searchModeOption: string = "contains";
  searchExprOption: any = "displayValue";
  searchTimeoutOption: number = 200;
  minSearchLengthOption: number = 0;

  ngOnChanges(){
    if (MiscUtil.checkArray(this.rows)){
        this.refreshOrder(this.rows);
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    let previousRowGroupName = this.rows[event.previousIndex].groupby;
    if(previousRowGroupName !== undefined){
     let previousRowGroupIndex = this.groupArray.findIndex(n=>n==previousRowGroupName);
     let currentRowGroupIndex = this.groupArray.findIndex(n=>n== this.rows[event.currentIndex].groupby);
     if(previousRowGroupIndex != currentRowGroupIndex){
       return;
     }
    }
    moveItemInArray(this.rows, event.previousIndex, event.currentIndex);
    this.refreshOrder(this.rows,true);
    this.orderUpdated.emit(this.infoLabel);
  }


  isListUnordered(list: ExpandableListItem[]) {
    return list.find((item, index) => item.order == 0 || item.order == undefined) != undefined ? true : false;
  }

  onAdd(){
    let rowsLengthBeforeAdd= this.rows.length;
    super.onAdd();
    let rowsLengthAfterAdd= this.rows.length;
    if(rowsLengthBeforeAdd != rowsLengthAfterAdd )
    {
      this.refreshOrder(this.rows);
      this.rowsChange.emit(this.rows);
    }

  }

  onRemove(id: number, skipCallBack: boolean)
  {
    super.onRemove(id, skipCallBack);
  }



}
